import { render } from "./ProgramDistributionChart.vue?vue&type=template&id=28e3c210"
import script from "./ProgramDistributionChart.vue?vue&type=script&lang=js"
export * from "./ProgramDistributionChart.vue?vue&type=script&lang=js"
script.render = render

export default script